import React, { useRef, useEffect } from 'react';
import styles from './section.module.css';
import { arrowIcon, blogImg1 } from '../../../assets';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SectionForth = () => {

    return (
        <div className={styles.blogSec_inner}>
            <div className={styles.blogSec_flex}>
                <div className={styles.blogSec_rgt}>
                    <div className={styles.blogSec_title}>
                        <h3>In The News</h3>
                    </div>
                    <div className={styles.blogSec_news}>
                        <ul className={styles.blogSec_newsLists}>
                            {[1, 2, 3].map((_, index) => (
                                <li key={index}>
                                    <div className={styles.blogSec_newsList}>
                                        <Link to="#">
                                            <p>Produce captivating audio content that keeps your audience coming back for more. We give your brand a voice that resonates.
                                            </p>
                                        </Link>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className={styles.blogSec_lft}>
                    <div className={styles.blogSec_title}>
                        <h3>Insights</h3>
                    </div>
                    <div className={styles.blogSec_blogLstP}>
                        <ul className={styles.blogSec_blogLst}>
                            {[1].map((_, index) => (
                                <li
                                    key={index}
                                    className={styles.card}
                                >
                                    <div className={styles.blogSec_lft_block}>
                                        <div className={styles.blogSec_lft_blockImg}>
                                            <img src={blogImg1} alt="" />
                                        </div>
                                        <div className={styles.blogSec_lft_blockDisc}>
                                            <p>Produce captivating audio content that keeps your audience coming back for more. We give your brand a voice that resonates.
                                            </p>
                                            <div className={styles.blogSec_lft_blockLink}>
                                                <Link to="#">
                                                    Explore More
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default SectionForth;
